var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundregister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 1080,
    viewBox: "0 0 960 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 1080,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 1080,
    fill: "#0451A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343 804.209C343 800.72 339.516 798.304 336.248 799.526L134.248 875.107C132.295 875.838 131 877.704 131 879.79V1072.68C131 1075.44 133.239 1077.68 136 1077.68H338C340.761 1077.68 343 1075.44 343 1072.68V804.209Z",
    fill: "#003AAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M958 46.9275C958 43.2504 954.164 40.8312 950.846 42.4154L786.846 120.709C785.107 121.539 784 123.295 784 125.221V408.072C784 411.75 787.836 414.169 791.154 412.585L955.154 334.291C956.893 333.461 958 331.705 958 329.779V46.9275Z",
    fill: "#FFD765"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181 65.6463C181 62.0402 177.299 59.62 173.995 61.0659L36.9952 121.028C35.1756 121.824 34 123.622 34 125.609V342.354C34 345.96 37.7013 348.38 41.0048 346.934L178.005 286.972C179.824 286.176 181 284.378 181 282.391V65.6463Z",
    fill: "#003AAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M960 699.928C960 696.25 956.164 693.831 952.846 695.415L788.846 773.709C787.107 774.539 786 776.295 786 778.221V1061.07C786 1064.75 789.836 1067.17 793.154 1065.58L957.154 987.291C958.893 986.461 960 984.705 960 982.779V699.928Z",
    fill: "#8FC1EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202 700.909C202 697.237 198.173 694.817 194.855 696.392L133.855 725.356C132.111 726.184 131 727.942 131 729.873V838.091C131 841.763 134.827 844.183 138.145 842.608L199.145 813.644C200.889 812.816 202 811.058 202 809.127V700.909Z",
    fill: "#003AAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85 6.61016C85 3.84874 82.7614 1.61017 80 1.61017H26C23.2386 1.61017 21 3.84874 21 6.61017V108.841C21 112.574 24.9434 114.991 28.27 113.296L82.27 85.7809C83.9452 84.9273 85 83.206 85 81.3259V6.61016Z",
    fill: "#003AAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M753 62.943C753 59.262 749.157 56.843 745.838 58.4346L687.838 86.2492C686.103 87.081 685 88.834 685 90.7576V195.057C685 198.738 688.843 201.157 692.162 199.565L750.162 171.751C751.897 170.919 753 169.166 753 167.242V62.943Z",
    fill: "#FFD765"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M755 892.697C755 889.078 751.274 886.657 747.968 888.128L704.968 907.256C703.163 908.059 702 909.849 702 911.824V984.303C702 987.922 705.726 990.343 709.032 988.872L752.032 969.744C753.837 968.941 755 967.151 755 965.176V892.697Z",
    fill: "#8FC1EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107 804.578C107 800.989 103.332 798.569 100.033 799.981L24.0331 832.499C22.1933 833.286 21 835.095 21 837.096V956.422C21 960.011 24.6679 962.431 27.9669 961.019L103.967 928.501C105.807 927.714 107 925.905 107 923.904V804.578Z",
    fill: "#003AAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundregister);
export default __webpack_public_path__ + "static/media/background register.8777d937036036894e0230d3e2464fa5.svg";
export { ForwardRef as ReactComponent };